import { inject } from 'vue';
import { allThemes } from '../styles/theme/themes/component-lib.esm.js';
function useTheme() {
  const theme = inject('currentTheme', {
    value: allThemes[0]
  });
  return theme;
}
export { useTheme };